"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.replace");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.subscribe = subscribe;
exports.unsubscribe = unsubscribe;

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createForOfIteratorHelper"));

var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));

var _url = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/url"));

var base = new _url.default(document.baseURI || window.location.href || '');
var subscribers = new _set.default();

function onStateChange(newState) {
  var _iterator = (0, _createForOfIteratorHelper2.default)(subscribers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var iterator = _step.value;
      iterator(newState);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

var handler = {
  apply: function apply(target, thisArg, args) {
    if (args[2] && args[2] !== window.location.pathname) {
      onStateChange(args[2].replace(base.pathname, '/'));
    }

    return target.apply(thisArg, args);
  }
};
window.history.pushState = new Proxy(window.history.pushState, handler);
window.history.replaceState = new Proxy(window.history.replaceState, handler);
window.addEventListener('hashchange', function (event) {
  onStateChange((event.newURL || window.location.hash).replace("".concat(base.toString(), "#"), ''));
});

function subscribe(fn) {
  subscribers.add(fn);
  return function () {
    return subscribers.delete(fn);
  };
}

function unsubscribe(fn) {
  if (subscribers.has(fn)) {
    subscribers.delete(fn);
  }
}
